import { useState } from "react";

/**
 * Lösenordsfält med fungerande visa/dölj.
 *
 * Knappen saknade tidigare type="button". En knapp i ett formulär är
 * type="submit" som standard, så varje klick på SHOW skickade
 * registreringsformuläret i stället för att visa lösenordet.
 *
 * aria-pressed säger vilket läge knappen är i, och aria-label beskriver vad
 * den gör — "SHOW" ensamt säger inget om vad som ska visas.
 */
export function PasswordInput({
  id,
  value,
  onChange,
  autoComplete,
  disabled,
  placeholder,
  ...aria
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete: "current-password" | "new-password";
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
  "aria-invalid"?: boolean;
  "aria-describedby"?: string;
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-input-wrapper">
      <input
        className="form-input"
        id={id}
        type={visible ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        disabled={disabled}
        placeholder={placeholder}
        {...aria}
      />

      <button
        className="toggle-password-visibility"
        type="button"
        onClick={() => setVisible((prev) => !prev)}
        aria-pressed={visible}
        aria-label={visible ? "Hide password" : "Show password"}
        disabled={disabled}
      >
        {visible ? "HIDE" : "SHOW"}
      </button>
    </div>
  );
}
